export default {
  root: {
    padding: [0, 8],
    '&:last-child': {
      textAlign: 'right',
      paddingRight: 20,
    },
  },
};
